var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-message"},[(_vm.message)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }